var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_Status_list_title"),
      pad: "0",
      widthClass: "max-1000",
      backgroundClass: "transparent",
    },
    scopedSlots: _vm._u([
      {
        key: "appendTitle",
        fn: function () {
          return [
            _c("span", { staticClass: "text-h4 text--secondary" }, [
              _vm._v(" - " + _vm._s(_vm.Data["swift_number"])),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "page-main",
        fn: function () {
          return [
            _vm.Data["nodes"].length == 0 ? _c("noContent") : _vm._e(),
            _vm.operating_staff && _vm.operating_staff.length
              ? _c(
                  "v-card",
                  {
                    staticClass: "pa-0 rounded-b-lg pb-1 mb-4",
                    attrs: { elevation: "0" },
                  },
                  [
                    _c(
                      "v-card-text",
                      { staticClass: "pa-0 d-flex flex-column rounded" },
                      [
                        _c("v-sheet", {
                          staticClass: "rounded-xl",
                          attrs: {
                            color: "primary",
                            height: "5",
                            width: "100%",
                          },
                        }),
                        _c(
                          "v-sheet",
                          { staticClass: "pa-3 text-h6 text--primary" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_Status_list_nextApproverLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _c(
                          "v-sheet",
                          {
                            staticClass: "pa-3 d-flex flex-row justify-end",
                            attrs: { width: "100%" },
                          },
                          [
                            _vm._l(_vm.operating_staff, function (item, index) {
                              return [
                                index < 2
                                  ? _c(
                                      "v-chip",
                                      {
                                        key: "staff---" + index,
                                        attrs: { pill: "" },
                                      },
                                      [
                                        _c("StaffAvatar", {
                                          attrs: {
                                            left: "",
                                            src: item.staff_avatar,
                                            staff_name: item.preferred_name,
                                          },
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$getCommonLangValue(
                                                item.preferred_name
                                              )
                                            ) +
                                            " "
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            }),
                            _vm.operating_staff.length > 2
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "text--secondary text-body-2",
                                  },
                                  [
                                    _vm._v(
                                      " .." +
                                        _vm._s(_vm.operating_staff.length - 2) +
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_Status_list_usersLabel"
                                          )
                                        )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._l(_vm.allNodes, function (item, index) {
              return [
                _c(
                  "v-sheet",
                  {
                    key: "node---" + index,
                    staticClass:
                      "transparent py-3 d-flex justify-start flex-column",
                  },
                  [
                    _c(
                      "v-sheet",
                      {
                        staticClass:
                          "\n            transparent\n            d-flex\n            flex-row\n            justify-start\n            align-center\n            flex-grow-1\n          ",
                      },
                      [
                        _c("v-sheet", {
                          attrs: { width: "5", height: "30", color: "primary" },
                        }),
                        _c(
                          "v-sheet",
                          {
                            staticClass:
                              "text-title px-2 text--secondary transparent",
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$getDateTime(item.date, "YYYY/MM/DD"))
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._l(item["nodes"], function (ite, ind) {
                      return [
                        _c(
                          "v-sheet",
                          {
                            key: "nodesss---" + ind,
                            staticClass:
                              "\n              rounded-lg\n              my-3\n              d-flex\n              flex-grow-1\n              pa-3\n              flex-row flex-nowrap\n            ",
                            attrs: { color: "white", height: "auto" },
                          },
                          [
                            _c(
                              "v-sheet",
                              {
                                staticClass: "text--secondary text-subtitle-1",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$getDateTime(
                                      ite["operate_utc_datetime"],
                                      "HH:mm"
                                    )
                                  )
                                ),
                              ]
                            ),
                            _c("v-sheet", {
                              attrs: {
                                color: "grey lighten-3 mx-3",
                                height: "auto",
                                width: "2",
                              },
                            }),
                            _c(
                              "v-sheet",
                              {
                                staticClass: "d-flex flex-column",
                                attrs: { height: "auto" },
                              },
                              [
                                _c(
                                  "v-sheet",
                                  { staticClass: "text-h5 text--primary py-1" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          ite.business_action
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "v-sheet",
                                  { staticClass: "text-h6 text--primary py-1" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_Status_list_handleLabel"
                                        )
                                      ) + " :"
                                    ),
                                  ]
                                ),
                                _c(
                                  "v-sheet",
                                  {
                                    staticClass:
                                      "d-flex flex-row justify-start py-1",
                                    attrs: { width: "100%" },
                                  },
                                  [
                                    _vm._l(
                                      ite.operating_staff,
                                      function (it, index) {
                                        return [
                                          index < 2
                                            ? _c(
                                                "v-chip",
                                                {
                                                  key: "staff---" + index,
                                                  attrs: { pill: "" },
                                                },
                                                [
                                                  _c("StaffAvatar", {
                                                    attrs: {
                                                      left: "",
                                                      src: it.staff_avatar,
                                                      staff_name:
                                                        it.preferred_name,
                                                    },
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$getCommonLangValue(
                                                          it.preferred_name
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]
                                      }
                                    ),
                                    ite.operating_staff.length > 2
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text--secondary text-body-2",
                                          },
                                          [
                                            _vm._v(
                                              " .." +
                                                _vm._s(
                                                  ite.operating_staff.length - 2
                                                ) +
                                                _vm._s(
                                                  _vm.$t(
                                                    "label_essweb_Status_list_usersLabel"
                                                  )
                                                )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                                ite.operate_comment
                                  ? _c(
                                      "v-sheet",
                                      {
                                        staticClass:
                                          "d-flex flex-row justify-start flex-grow-1",
                                      },
                                      [
                                        _c("svg-icon", {
                                          attrs: {
                                            size: "24",
                                            fill: "grey",
                                            iconClass: "Doc",
                                          },
                                        }),
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass: "text-ellipsis-4",
                                            staticStyle: {
                                              "max-width": "400px",
                                            },
                                            attrs: { width: "100%" },
                                          },
                                          [_vm._v(_vm._s(ite.operate_comment))]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    }),
                  ],
                  2
                ),
              ]
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }